export enum AlertType {
  Success = 'alert-success',
  Error = 'alert-danger',
  Info = 'alert-info',
  Warning = 'alert-warning'
}
